// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/dialog.scss
// module id = 96
// module chunks = 0